import { render, staticRenderFns } from "./IconRefresh.vue?vue&type=template&id=60b5ae62&"
var script = {}
import style0 from "./IconRefresh.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60b5ae62')) {
      api.createRecord('60b5ae62', component.options)
    } else {
      api.reload('60b5ae62', component.options)
    }
    module.hot.accept("./IconRefresh.vue?vue&type=template&id=60b5ae62&", function () {
      api.rerender('60b5ae62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/IconRefresh.vue"
export default component.exports